import { Button, Modal, Input, Table, Tag } from '@driftt/tide-core-legacy'
import { DateRangePicker, isAfter, isBefore } from 'react-dates'
import moment from 'moment'
import cx from 'classnames'
import { startCase } from 'lodash'

import './style.styl'

const BusinessExportModal = ({
  open,
  onClose,
  onDateChange,
  onDatePickerFocus,
  startDate,
  endDate,
  focusedInput,
  sourceId,
  isOutsideRange = (day) => day.isAfter(moment()) || day.isBefore(moment().subtract(60, 'days')),
  isDayBlocked = () => (false),
  initialVisibleMonth= () => moment().subtract(1, 'month'),
  exportRequestPending,
  onClickExportButton,
  disabledReason,
  
}) => (
  <Modal open={open} onClose={onClose} className="export-business-events-modal" size="medium">
    <div className="export-business-events-modal-body">
      <div>
        <h2 className="export-business-events-modal-header">Export your {startCase(sourceId)} activity</h2>
        <p className="export-business-events-modal-subtitle">You can export up to the last 60 days of log history</p>
        <div className="export-business-events-modal-part-one">
          <div className="export-business-events-modal-date-picker">
            <div><span className="export-business-events-modal-date-picker--from">From</span><span>To</span></div>
            <DateRangePicker
              startDate={startDate}
              endDate={endDate}
              onDatesChange={onDateChange}
              focusedInput={!!focusedInput ? focusedInput : "startDate"}
              onFocusChange={onDatePickerFocus}
              isOutsideRange={isOutsideRange}
              enableOutsideDays={false}
              isDayBlocked={isDayBlocked}
              hideKeyboardShortcutsPanel
              initialVisibleMonth={initialVisibleMonth}
            />
          </div>
        </div>
      </div>
    
    </div>
    <footer className="export-business-events-modal-footer">
      <Button type="primary" disabled={exportRequestPending || !!disabledReason} loading={exportRequestPending} className="export-business-events-modal-footer--export-button" onClick={onClickExportButton}>Export CSV</Button>
      <Button type="tertiary" onClick={onClose}>Cancel</Button>
      {!!disabledReason && <span className="export-business-events-disabled-reason">{disabledReason}</span>}
    </footer>
  </Modal>
)

export default BusinessExportModal


// WEBPACK FOOTER //
// ./src/scripts/components/Integration/components/BusinessEventExportModal/component.js